// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__33dfB","description":"PatientConsentPreview_description__3QdZB"};